import { TextBase } from '@carboncopyco/ui';
import type React from 'react';
import { RuleArrow } from './RuleArrow';
import { RuleTooltip } from './RuleTooltip';

export interface RulePreviewProps {
  children?: React.ReactNode;
}

export const RulePreview = ({ children }: RulePreviewProps) => {
  return (
    <div className="w-full flex flex-row items-center gap-2.5">{children}</div>
  );
};

export const TextTitleWithTooltip = ({
  label,
  isDisabled,
}: {
  label: string;
  isDisabled?: boolean;
}) => {
  const text = label || 'Untitled tooltip';

  return (
    <RulePreview.Tooltip title={text}>
      <span className="truncate">
        <TextBase
          label={text}
          color={isDisabled ? 'text-ds-natural-200' : 'text-ds-natural-600'}
          ellipsis
        />
      </span>
    </RulePreview.Tooltip>
  );
};

RulePreview.Arrow = RuleArrow;
RulePreview.Tooltip = RuleTooltip;
